import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { consoleAPI } from '@/providers/apis/console/console';
import { EDUCATORS_SUB_ARRAY, PARTNERS_TYPE, PERMISSION_CHECK } from '@/utils/constants';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'partner-list',
    components: {
        'g-icon': GoogleMaterialIcon,
    },
})

export default class PartnerList extends Vue {

    // ----------------------------------------------------------------------------
    // Properties

    private partnerList: any = [];

    private storedList: any = [];

    private get partnerType() {
        return this.$route.params.type;
    }

    private permissonCheck = PERMISSION_CHECK;

    private get partnerName() {
        return PARTNERS_TYPE.find((item) => item.type === this.partnerType);
    }


    // ---------------------------------------------------------------------------------
    // Hooks

    private created() {
        if (this.partnerType !== 'educators') {
            this.getPartnerByTypes();
        } else {
            this.getPartnerForEducator();
        }
    }

    // ----------------------------------------------------------------------------------
    // Actions

    private getPartnerByTypes() {
        const params = {
            type: this.partnerType,
        };
        consoleAPI.fetchPartnerByType(params).then((partners) => {
            this.storedList = this.partnerList = partners[this.partnerType];
        });
    }

    private getPartnerForEducator() {
        const educatorType = EDUCATORS_SUB_ARRAY;
        let educatorList: any = [];
        let index = 0;
        for (const iterator of educatorType) {
            const params = {
                type: iterator,
            };
            consoleAPI.fetchPartnerByType(params).then((partners) => {
                index++;
                educatorList = [...educatorList, ...partners[iterator]];
                // this.storedList = this.partnerList = partners[iterator];
                if (educatorType.length === index) {
                    this.storedList = this.partnerList = educatorList;
                }
            });
        }
    }

    private onCreatePartners() {
        this.$router.push(`/console/partners/create?type=${this.partnerType}`);
    }

    private onEditPartner(partner: any) {
        this.$router.push(`/console/partners/${partner.partner_id}/details?type=${this.partnerType}`);
    }

    private onGoBack() {
        this.$router.push('/console/partners/collaborators-list');
    }

    private onSearch(event: any) {
        const value = event.target.value;
        this.partnerList = [...this.storedList].filter(
            (item) => item.partner_name.toLowerCase().startsWith(value.toLowerCase()));
    }


    // ----------------------------------------------------------------------------------
    // Methods

    private findParntnerName(value: string) {
        const obj = PARTNERS_TYPE.find((item) => item.type === value);
        return obj && obj.name ? obj.name : null;
    }
}
